import script from "./IntroPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroPage.vue?vue&type=script&setup=true&lang=js"

import "./IntroPage.vue?vue&type=style&index=0&id=a0dc9036&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0dc9036"]])

export default __exports__